export const IS_SAFARI = /^((?!chrome|android).)*safari/i.test(navigator.userAgent.toLowerCase());
export const IS_IOS = /iphone|ipod|ipad/i.test(navigator.userAgent.toLowerCase());
export const IS_PORTABLE =
  /iphone|ipod|ipad|android|blackberry|opera mini|opera mobi|maemo|windows phone|iemobile/i.test(
    navigator.userAgent.toLowerCase(),
  );
export const IS_PHONE = IS_PORTABLE && (screen.width <= 480 || screen.height <= 480);
export const IS_TABLET = IS_PORTABLE && !IS_PHONE && (screen.width <= 1024 || screen.height <= 1024);
export const IS_MAC = /macintosh|mac os x/i.test(navigator.userAgent.toLowerCase()) && !IS_IOS;
